import { FC, ReactElement } from 'react';

import { RequestResetPasswordForm } from '../../../containers';
import { RequestResetPasswordFormData } from '../../../entities/@forms/RequestResetPasswordForm/RequestResetPasswordForm';
import { requestResetPassword } from '../../../redux/@account/resetPassword/resetPasswordActions';
import { useTypedDispatch, useTypedSelector } from '../../../redux/store';

interface ConnectedRequestResetPasswordFormProps {
    className?: string;
}

export const ConnectedRequestResetPasswordForm: FC<ConnectedRequestResetPasswordFormProps> = ({
    className = '',
}): ReactElement => {
    const dispatch = useTypedDispatch();

    const isLoading = useTypedSelector(state => state.resetPasswordSlice.isLoading);
    const error = useTypedSelector(state => state.resetPasswordSlice.error);

    const handleSubmit = (formData: RequestResetPasswordFormData): void => {
        dispatch(requestResetPassword(formData));
    };

    return (
        <RequestResetPasswordForm
            isLoading={isLoading}
            error={error}
            onSubmit={handleSubmit}
            className={className}
        />
    );
};
